let config = {};

export async function loadConfig(location) {
  if (typeof location !== 'string') {
    throw new Error('location must be a string');
  }

  try {
    const response = await fetch(location);
    if (!response.ok) {
      console.warn(`Failed to fetch config from ${location}: ${response.statusText}`);
      return config;
    }
    config = await response.json();
    return config;
  } catch (error) {
    console.error('Error loading config:', error);
    throw error;
  }
}

export function getConfig () {
  return config;
}

// Helper function to reset config (for testing purposes)
export function resetConfig() {
  config = {};
}